import Vue from "vue";

const requireComponent = require.context("@/components/_base/", true, /[A-Z]/);
requireComponent.keys().forEach(fileName => {
  let baseComponentConfig = requireComponent(fileName);
  baseComponentConfig = baseComponentConfig.default || baseComponentConfig;
  const baseComponentName =
    baseComponentConfig.name ||
    "Base" + fileName.replace(/^.+\//, "").replace(/\.\w+$/, "");
  Vue.component(baseComponentName, baseComponentConfig);
});



// WEBPACK FOOTER //
// ./src/settings/baseComponents.js